import React from 'react';
import { T } from '../designTokens';

export default function RouteFallback() {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        backgroundColor: T.gray800,
        borderRadius: '10px',
        padding: '48px',
        textAlign: 'center',
        border: `1px solid ${T.overlaySoft}`,
      }}
    >
      <h3 style={{ margin: '0 0 8px', color: T.gray100, fontFamily: T.fontBody, fontWeight: 700, fontSize: '18px' }}>
        Loading…
      </h3>
    </div>
  );
}
